<template>
  <div class="wrapper-box-limit">
    <div class="text-center box-limit-plan-free" id="box-limit-plan" :class="{'show': activeAfterResize}">
      {{ $i18nPresenter.t(
        'This presentation has exceeded the question limit. You can still present it to 3 participants.') }} <br />
      {{ $i18nPresenter.t(
        'To remove the limit, please'
      ) }}
      <b
        class="underline font-bold cursor-pointer"
        @click="openPlanUpgradeModal"
      >{{ $i18nPresenter.t('upgrade') }}</b> {{ $i18nPresenter.t('or delete some') }}
      <img src="@/assets/images/pro.svg" class="cursor-pointer ml-1 inline-block mr-1 mb-1"> slides.
      <a
        href="https://help.ahaslides.com/portal/en/kb/articles/what-is-included-in-the-free-account"
        target="_blank"
        class="underline hover:text-primary-90"
      >{{ $i18nPresenter.t('Learn more…') }}</a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  components: {
  },
  data() {
    return {
      activeAfterResize: false,
    }
  },
  computed: {
    ...mapGetters(['planLimit']),
    ...mapState({
      planBenefitLimitation: (state) => state.planBenefitLimitation,
      presentation: (state) => state.presentation,
    }),
  },
  mounted() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
      this.activeAfterResize = true
    }, 100)
  },
  methods: {
    openPlanUpgradeModal() {
      utils.mixpanelTracking(
        null,
        'click_textlink_upgrade_middle',
        'QuestionLimit',
        null,
        {
          element_name: 'Upgrade for higher participant limit (limit: 3)',
          page: eventCategories.PRESENTATION_EDITOR,
          presentation_id: this.presentation.id,
        },
      )
      this.$router.push('/apps/user-plan')
    },
  },
}
</script>

<style lang="scss" scoped>
.box-limit-plan-free {
  font-size: 14px;
  background-color: #FFF7EA;
  padding: 8px 16px;
  border-radius: 4px;
  line-height: 18px;
  margin: 0 auto;
  width: 100%;
  max-width: 100%;
  opacity: 0;

  &.show {
    opacity: 1;
  }
}
.wrapper-box-limit {
  margin-bottom: 16px;
}
</style>
